import { certificateConstants } from '../constants';
import { certificateRequests } from '../../services';
import { handleErrorMessage } from '../../utils';

export const certificateActions = {}

certificateActions.RegisterCertificateType01 = (data) => {
  return dispatch => {
    dispatch(request())
    certificateRequests.RegisterCertificateType01(data)
      .then(
        regCertData => dispatch(success(regCertData)),
        error => dispatch(failure(handleErrorMessage(error)))
      )
  }

  function request() {
    return { type: certificateConstants.REGISTER_TYPE01_REQUEST }
  }

  function success(regCertData) {
    return { type: certificateConstants.REGISTER_TYPE01_SUCCESS, regCertData }
  }

  function failure(error) {
    return { type: certificateConstants.REGISTER_TYPE01_FAILURE, error }
  }
}

certificateActions.RegisterCertificateType02 = (data) => {
  return dispatch => {
    dispatch(request())
    certificateRequests.RegisterCertificateType02(data)
      .then(
        regCertUpdData => dispatch(success(regCertUpdData)),
        error => dispatch(failure(handleErrorMessage(error)))
      )
  }

  function request() {
    return { type: certificateConstants.REGISTER_TYPE02_REQUEST }
  }

  function success(regCertUpdData) {
    return { type: certificateConstants.REGISTER_TYPE02_SUCCESS, regCertUpdData }
  }

  function failure(error) {
    return { type: certificateConstants.REGISTER_TYPE02_FAILURE, error }
  }
}

certificateActions.GetDocumentCertificate = () => {
  return dispatch => {
    dispatch(request())
    certificateRequests.GetDocumentCertificate()
      .then(
        getDocCertData => dispatch(success(getDocCertData)),
        error => dispatch(failure(handleErrorMessage(error)))
      )
  }

  function request() {
    return { type: certificateConstants.GETDOCUMENT_REQUEST }
  }

  function success(getDocCertData) {
    return { type: certificateConstants.GETDOCUMENT_SUCCESS, getDocCertData }
  }

  function failure(error) {
    return { type: certificateConstants.GETDOCUMENT_FAILURE, error }
  }
}

